import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="about-container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img\annwesha\2026edition.jpg" className="img-responsive" alt="img"  style={{
            //Below lines will help to set the border radius
            borderBottomLeftRadius: 30,
            borderBottomRightRadius: 15,
            borderTopRightRadius: 30,
            borderTopLeftRadius: 15,
            overflow: 'hidden',
          }} />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2 style={{padding:10}}>About the Journal</h2>
              <p style={{textAlign: 'justify'}}>{props.data ? props.data.paragraph : "loading..."}</p>
              <h3>Key facts</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}> {d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
